import type {
  WorkspaceUserSearchQuery,
  WorkspaceUserSearchResponseApi,
  WorkspaceUserSearchResultApi,
} from "./workspaceMembers.types";

/**
 * Figma 2858:215537 — default search results when query is "Na".
 * Order matches the design: Nancy → Naveen → Nainika.
 */
export const FIGMA_WORKSPACE_SEARCH_DEMO_USERS: WorkspaceUserSearchResultApi[] =
  [
    {
      id: "u-nancy",
      name: "Nancy Thomas",
      email: "nancy@magicbi.ai",
      title: "Data analyst",
      avatar_url: null,
    },
    {
      id: "u-naveen",
      name: "Naveen Sharma",
      email: "naveen@magicbi.ai",
      title: "Product manager",
      avatar_url: null,
    },
    {
      id: "u-nainika",
      name: "Nainika Shah",
      email: "nainika@magicbi.ai",
      title: "Customer success manager",
      avatar_url: null,
    },
  ];

/** Extra directory entry for email-invite flow testing (not in Figma search screenshot). */
const EXTRA_MOCK_USERS: WorkspaceUserSearchResultApi[] = [
  {
    id: "u-barry",
    name: "Barry Allen",
    email: "barry@gmail.com",
    title: null,
    avatar_url: null,
  },
];

export const MOCK_WORKSPACE_USER_DIRECTORY: WorkspaceUserSearchResultApi[] = [
  ...FIGMA_WORKSPACE_SEARCH_DEMO_USERS,
  ...EXTRA_MOCK_USERS,
];

const MIN_QUERY_LENGTH = 2;

const matchesQuery = (
  user: WorkspaceUserSearchResultApi,
  q: string,
): boolean =>
  user.name.toLowerCase().includes(q) ||
  user.email.toLowerCase().includes(q);

export const mockSearchWorkspaceUsers = async (
  query: WorkspaceUserSearchQuery,
): Promise<WorkspaceUserSearchResponseApi> => {
  const q = query.q.trim().toLowerCase();
  const limit = query.limit ?? 10;

  if (q.length < MIN_QUERY_LENGTH) {
    return { items: [], query: q };
  }

  await new Promise((resolve) => setTimeout(resolve, 120));

  // Figma demo: typing "Na" returns exactly the three design rows in order.
  if (q === "na") {
    return {
      items: FIGMA_WORKSPACE_SEARCH_DEMO_USERS.slice(0, limit),
      query: q,
    };
  }

  const items = MOCK_WORKSPACE_USER_DIRECTORY.filter((user) =>
    matchesQuery(user, q),
  ).slice(0, limit);

  return { items, query: q };
};
